// Mock data for Max's Concrete Cutting Perth
// NOTE: This is FRONTEND MOCK data. Quote submissions & bookings are saved to localStorage for now.

export const business = {
  name: "Max's Concrete Cutting Perth",
  short: "Max's Concrete Cutting",
  owner: "Max",
  phone: "0435 237 153",
  phoneHref: "tel:0435237153",
  smsHref: "sms:+61435237153?&body=Hi%20Max%2C%20I%27d%20like%20a%20quote%20for%20some%20concrete%20cutting%3A%20",
  email: "Muamet13@gmail.com",
  area: "Perth & Surrounds",
  region: "Western Australia",
  abn: "Fully insured \u00b7 Owner operated",
};

// Price promises / small-job focus
export const promises = [
  { title: "No call-out fees", text: "We don\u2019t charge just to turn up. You only pay for the cut." },
  { title: "No minimum job", text: "One core hole or a full driveway \u2014 no job is too small." },
  { title: "Beat any reputable quote", text: "Got a reputable written quote? We\u2019ll beat it by at least 10%." },
];

// Max's availability (matches his FIFO roster). freeDays = available to book.
// Any day in the month NOT listed in freeDays is booked / away on shift.
export const availability = {
  months: [
    { key: "2026-10", label: "October 2026", year: 2026, month: 10, freeDays: [1, 2, 3, 4, 20, 21, 22, 23, 24, 25] },
    { key: "2026-11", label: "November 2026", year: 2026, month: 11, freeDays: [10, 11, 12, 13, 14, 15] },
    { key: "2026-12", label: "December 2026", year: 2026, month: 12, freeDays: [1, 2, 3, 4, 5, 6, 22, 23, 24, 25, 26, 27] },
  ],
};

export const timeSlots = ["7:00 AM", "9:00 AM", "11:00 AM", "1:00 PM", "3:00 PM"];

// Attached job photos
export const photos = {
  grooveTopDown: "https://customer-assets-m6fa6gv7.emergentagent.net/job_94609f66-a501-45a7-ba66-93a2b70e4ba1/artifacts/ex69pl3r_IMG_9486.jpg",
  channelPolished: "https://customer-assets-m6fa6gv7.emergentagent.net/job_94609f66-a501-45a7-ba66-93a2b70e4ba1/artifacts/a5l7s1xr_IMG_9485.jpg",
  excavator: "https://customer-assets-m6fa6gv7.emergentagent.net/job_94609f66-a501-45a7-ba66-93a2b70e4ba1/artifacts/xqza18dv_IMG_9488.jpg",
  slabLift: "https://customer-assets-m6fa6gv7.emergentagent.net/job_94609f66-a501-45a7-ba66-93a2b70e4ba1/artifacts/i20sr0b4_IMG_9487.jpg",
};

export const services = [
  {
    num: "01",
    tag: "Most requested",
    title: "Concrete Slab Sawing",
    blurb: "Clean, dead-straight cuts through driveways, paths and floors, depth-controlled to protect what\u2019s underneath.",
  },
  {
    num: "02",
    tag: "",
    title: "Wall Sawing",
    blurb: "Precise door, window and vent openings cut into block and reinforced walls with a track-mounted saw.",
  },
  {
    num: "03",
    tag: "",
    title: "Core Drilling",
    blurb: "Neat circular holes for plumbing, drainage, ducting and services, from 25mm right up to 450mm.",
  },
  {
    num: "04",
    tag: "",
    title: "Bathroom Strip-Outs",
    blurb: "Cut-and-lift removal of old bathroom slabs and floors, ready for the plumber and a fresh renovation.",
  },
  {
    num: "05",
    tag: "",
    title: "Kitchen Strip-Outs",
    blurb: "Tidy demolition of kitchen floors and hobs, sawn into manageable sections and carted away clean.",
  },
  {
    num: "06",
    tag: "",
    title: "Demolition & Removal",
    blurb: "Mini-excavator break-up and full site clean-up. We cut it, lift it, load it and leave the site tidy.",
  },
];

export const galleryItems = [
  { img: photos.grooveTopDown, title: "Drainage Channel Cut", cat: "Slab Sawing" },
  { img: photos.channelPolished, title: "Polished Floor Channel", cat: "Precision Cutting" },
  { img: photos.excavator, title: "Driveway Break-Out", cat: "Demolition" },
  { img: photos.slabLift, title: "Patio Slab Lift & Remove", cat: "Removal" },
];

export const steps = [
  { n: "01", title: "Send the details", text: "Tell us the job, slab, wall, core or strip-out, and drop a photo if you\u2019ve got one." },
  { n: "02", title: "Get a fair price", text: "You\u2019ll get a straight answer and an honest quote, usually the same day." },
  { n: "03", title: "We cut it clean", text: "On time, dust managed, edges sharp, and the site left tidy when we\u2019re done." },
];

export const testimonials = [
  {
    quote: "Cut a perfect drainage channel through our polished concrete without a chip out of place. You\u2019d never know where he stopped and started.",
    name: "Daniel R.",
    place: "Scarborough",
  },
  {
    quote: "Needed the old bathroom floor cut out for a reno. Fast, clean, barely any dust and the site was spotless after. Highly recommend.",
    name: "Kylie M.",
    place: "Canning Vale",
  },
  {
    quote: "Broke up and carted away a whole driveway in a morning. Sharp pricing and did exactly what he said he would.",
    name: "Steve P.",
    place: "Joondalup",
  },
];

export const stats = [
  { value: "500+", label: "Cuts completed" },
  { value: "Same day", label: "Quotes" },
  { value: "10+ yrs", label: "On the tools" },
  { value: "Perth", label: "Wide coverage" },
];

export const jobTypes = [
  "Slab / Floor Sawing",
  "Wall Sawing",
  "Core Drilling",
  "Bathroom Strip-Out",
  "Kitchen Strip-Out",
  "Demolition & Removal",
  "Not sure / Other",
];
